import React, { useState } from 'react';
import { Button, Form, Offcanvas } from "react-bootstrap";
import MultiSelect from '../../components/MultiSelect';
import { Badge, Tab, Nav, Table, ListGroup } from 'react-bootstrap';
import SearchSelect from '../../components/SearchSelect';
const LeadsSide = ({ show, close }) => {
    const [activeTab, setActiveTab] = useState('alerts');
    const alertData = [
        {
            name: 'Product A',
            type: 'Type A',
            createdAt: '2024-03-09T12:00:00',
        },
        {
            name: 'Product B',
            type: 'Type B',
            createdAt: '2024-03-08T10:30:00',
        },
        {
            name: 'Product C',
            type: 'Type C',
            createdAt: '2024-03-07T15:45:00',
        },
        {
            name: 'Product D',
            type: 'Type D',
            createdAt: '2024-03-06T11:20:00',
        },
        {
            name: 'Product E',
            type: 'Type E',
            createdAt: '2024-03-05T09:10:00',
        },
        {
            name: 'Product F',
            type: 'Type F',
            createdAt: '2024-03-04T14:30:00',
        },
        {
            name: 'Product G',
            type: 'Type G',
            createdAt: '2024-03-03T08:45:00',
        },
        {
            name: 'Product H',
            type: 'Type H',
            createdAt: '2024-03-02T10:00:00',
        },
        {
            name: 'Product I',
            type: 'Type I',
            createdAt: '2024-03-01T13:20:00',
        },
        {
            name: 'Product J',
            type: 'Type J',
            createdAt: '2024-02-29T09:30:00',
        },
    ];
    return (
        <>
            <Offcanvas show={show} className="canvas-lg bg-light" onHide={close} placement="end">
                <Offcanvas.Header>
                    <Offcanvas.Title>
                        Lead Details
                    </Offcanvas.Title>
                    <button type="button" className="btn-close" aria-label="Close" onClick={close}><i className="ri-close-line"></i></button>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="row">
                        <div className="col-md-9">
                            <div className="card border shadow-sm">
                                <div className="card-header">
                                    <h4>ID#0001</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="single-data mt-4">
                                                <h5 className="text-cen3er">Lead Info</h5>
                                                <div className="row mt-3">
                                                    <div className="col-lg-3">
                                                        <div className="mb-2">
                                                            <label className="form-label">Name:</label>
                                                            <p>Muhammad Usama</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="mb-2">
                                                            <label className="form-label">Email:</label>
                                                            <p>usamaasif4190@gmail.com</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="mb-2">
                                                            <label className="form-label">Phone Number:</label>
                                                            <p>+923456413071</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="mb-2">
                                                            <label className="form-label">Gender:</label>
                                                            <p>Male</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="mb-2">
                                                            <label className="form-label">Notes:</label>
                                                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore, doloremque. Nostrum eos quo minus? Veritatis illum mollitia quasi illo dolorum deleniti quos doloremque blanditiis.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="single-data mt-4">
                                                <h5 className="text-left">Address Information</h5>
                                                <div className="row mt-3">
                                                    <div className="col-lg-12">
                                                        <div className="mb-2">
                                                            <label className="form-label">Street Address:</label>
                                                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="mb-2">
                                                            <label className="form-label">Appt Number:</label>
                                                            <p>120393</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="mb-2">
                                                            <label className="form-label">City:</label>
                                                            <p>Karachi</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="mb-2">
                                                            <label className="form-label">State:</label>
                                                            <p>Sindh</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="mb-2">
                                                            <label className="form-label">Zip Code:</label>
                                                            <p>78850</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="mb-2">
                                                            <label className="form-label">Metro Area:</label>
                                                            <p>Habib Metro</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="d-flex gap-2 mt-3"><button type="button" className="text-white px-5  btn btn-primary" data-dashlane-label="true" data-dashlane-rid="8e865cb1e4d1fe99" data-form-type="">Edit</button><button type="button" className="text-white px-5 btn btn-danger" data-dashlane-label="true" data-dashlane-rid="389c8d26ebcd8d16" data-form-type="">Delete</button></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Tab.Container activeKey={activeTab} onSelect={(key) => setActiveTab(key)}>
                                <Nav variant="tabs">
                                    <Nav.Item>
                                        <Nav.Link eventKey="alerts">Alerts</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="history">History</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <div className="card">
                                    <div className="card-body">
                                        <Tab.Content>
                                            <Tab.Pane eventKey="alerts">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <Form >
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Select Alert:</Form.Label>

                                                                <SearchSelect
                                                                    options={
                                                                        [
                                                                            { value: 'Alert A', label: 'Alert A' },
                                                                            { value: 'Alert B', label: 'Alert B' },
                                                                            { value: 'Alert C', label: 'Alert C' }
                                                                        ]
                                                                    }
                                                                    placeholder={"Select Alert"}
                                                                />
                                                            </Form.Group>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Alert Message:</Form.Label>
                                                                <Form.Control type="text" placeholder="Enter alert message" />
                                                            </Form.Group>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Description:</Form.Label>
                                                                <Form.Control as="textarea" rows={3} placeholder="Enter description" />
                                                            </Form.Group>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Alert Type:</Form.Label>
                                                                <Form.Select aria-label="Select alert type">
                                                                    <option value="email">Email</option>
                                                                    <option value="notification">Notification</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Date/Time:</Form.Label>
                                                                <Form.Control type="datetime-local" />
                                                            </Form.Group>
                                                            <Button variant="primary">
                                                                Add
                                                            </Button>
                                                        </Form>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="table-responsive">
                                                            <Table striped bordered hover>
                                                                <thead>
                                                                    <tr>
                                                                        <th>Name</th>
                                                                        <th>Type</th>
                                                                        <th>Created At</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {alertData.map((row, index) => (
                                                                        <tr key={index}>
                                                                            <td>{row.name}</td>
                                                                            <td>{row.type}</td>
                                                                            <td>{row.createdAt}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="history">

                                                <Table striped bordered hover>
                                                    <thead>
                                                        <tr>
                                                            <th>Date</th>
                                                            <th>User</th>
                                                            <th>Message</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>01/01/2024</td>
                                                            <td>User 1</td>
                                                            <td>Message 1</td>
                                                        </tr>
                                                        <tr>
                                                            <td>01/02/2024</td>
                                                            <td>User 2</td>
                                                            <td>Message 2</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </div>
                                </div>
                            </Tab.Container>
                        </div>
                        <div className="col-md-3" style={{position: "sticky", top: 0}}>
                            <div className="side-bar">
                                <div className="card border shadow-sm">
                                    <div className="card-header bg-info">
                                        <span className='text-white'><span className=" font-weight-bold">Last Activity:</span> 7/4/2023 11:18AM</span>
                                    </div>
                                    <ul className="list-group">


                                        <li className="list-group-item d-flex justify-content-between">
                                            <span className=" text-muted">Created On:</span>
                                            <span className=" font-weight-semibold font-13">02/23/2024</span>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between">
                                            <span className=" text-muted">Updated On:</span>
                                            <span className=" font-weight-semibold font-13">02/23/2024</span>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between">
                                            <span className=" text-muted">Country:</span>
                                            <span className=" font-weight-semibold font-13">Nostrum esse ut quas</span>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between">
                                            <span className=" text-muted">Zip:</span>
                                            <span className=" font-weight-semibold font-13">52434</span>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between">
                                            <Form.Group>
                                                <Form.Label>Tags</Form.Label>
                                                {/* <TagsInput /> */}
                                                <div>
                                                    <Badge variant="primary" className="me-1 mb-1">Tag1</Badge>
                                                    <Badge variant="secondary" className="me-1 mb-1">Tag2</Badge>
                                                    <Badge variant="success" className="me-1 mb-1">Tag3</Badge>
                                                    <Badge variant="danger" className="me-1 mb-1">Tag4</Badge>
                                                </div>
                                            </Form.Group>
                                        </li>

                                        <li className="list-group-item  pt-5">
                                            <span className=" font-weight-bold d-block mb-2">Created By:</span>

                                            <div className="d-flex gap-2 align-items-center">
                                                <img src="https://i2.wp.com/ui-avatars.com/api//Lasse%20Rafn/45?ssl=1" className='user-image' alt="" />
                                                <span className=" font-weight-semibold font-13">User A</span>
                                            </div>
                                        </li>
                                        <li className="list-group-item ">
                                            <span className=" font-weight-bold d-block mb-2">Updated By:</span>

                                            <div className="d-flex gap-2 align-items-center">
                                                <img src="https://i2.wp.com/ui-avatars.com/api//Lasse%20Rafn/45?ssl=1" className='user-image' alt="" />
                                                <span className=" font-weight-semibold font-13">User A</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
                {/* <Offcanvas.Header>
                    <div className="col-6">
                        <Button variant="primary" className="text-white w-100 fw-bold">
                            Reset
                        </Button>
                    </div>
                    <div className="col-6">
                        <Button variant="primary" onClick={close} className="text-white w-100 fw-bold">
                            Filter
                        </Button>
                    </div>
                </Offcanvas.Header> */}
            </Offcanvas >
        </>
    );
};

export default LeadsSide;